module.exports = __webpack_public_path__ + "static/media/backIcon.d6847cde.svg";